import { Link } from "react-router-dom";
import { IconArrow } from "./icons";

type Props = { heading?: string; sub?: string };

export default function CtaBand({
  heading = "Got something that needs shipping?",
  sub = "Tell us what you're trying to do. We'll come back with a plan and a straight answer on cost and timing.",
}: Props) {
  return (
    <section className="section">
      <div className="container">
        <div className="ctaband">
          <div>
            <h2>{heading}</h2>
            <p>{sub}</p>
          </div>
          <Link to="/contact" className="btn">
            Start a project <IconArrow />
          </Link>
        </div>
      </div>
    </section>
  );
}
